// Browser translators (Chrome, Edge) replace the text nodes React rendered
// with <font> wrappers. When React later removes or inserts next to one of
// those nodes, the DOM throws "The node to be removed is not a child of this
// node" and the root error boundary wipes the page (HEAPSGO-2PF,
// https://github.com/facebook/react/issues/11538). These patches make the
// mismatch a no-op instead of a crash. Install before React renders.
export const installDomTranslationGuard = () => {
  if (typeof Node !== "function" || !Node.prototype) {
    return
  }

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        child.parentNode.removeChild(child)
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
